import * as models from "./api/models";
import * as endpoints from "./api/endpoints";
import * as error from "./api/error";

export default function callApplicationLead(
    fieldName: string,
    invitationCode: string | null,
    url: string,
    value?: string,
) {
    const field: models.FieldChangeInfo[] = [
        {
            field: fieldName,
            value: value ? value : "",
            timestamp: new Date().toISOString(),
        },
    ];

    endpoints
        .applicationLead(field, invitationCode, url)
        .catch((err) => error.reportAxios(err, "callApplicationLead"));
}
